// import request from '@/config/request'
import request from 'axios'
import CFG from '@/config/config.json'

export const getQygw = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getQygw?systemSid='+systemSid,
        method: 'get',
    })
}

export const getTemp = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getTemp?systemSid='+systemSid,
        method: 'get',
    })
}

export const getConfig = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getConfig?systemSid='+systemSid,
        method: 'get',
    })
}

export const getOrgByDevice = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getOrgByDevice?systemSid='+systemSid,
        method: 'get',
    })
}

export const getByDevice = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getDevice?systemSid='+systemSid,
        method: 'get',
    })
}

// 首页数据查询
export const getAreaAndType = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getAreaAndType?systemSid='+systemSid,
        method: 'get',
    })
}

export const getRangelandChart = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getRangelandChart?systemSid='+systemSid,
        method: 'get',
    })
}

export const getGrasslandGradeChart = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getGrasslandGradeChart?systemSid='+systemSid,
        method: 'get',
    })
}

export const getGrasslandClassChart = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getGrasslandClassChart?systemSid='+systemSid,
        method: 'get',
    })
}

export const getTypeChart = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getTypeChart?systemSid='+systemSid,
        method: 'get',
    })
}

export const getDegradationChart = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getDegradationChart?systemSid='+systemSid,
        method: 'get',
    })
}


export const getVegetationCoverageChart = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getVegetationCoverageChart?systemSid='+systemSid,
        method: 'get',
    })
}

export const getPestData = (ids) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getPestData?ids='+ids,
        method: 'get',
    })
}


export const getRangelandTable = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getRangelandTable?systemSid='+systemSid,
        method: 'get',
    })
}

export const getRangelandTable2 = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getRangelandTable2?systemSid='+systemSid,
        method: 'get',
    })
}

export const getSteppeTableChart = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getSteppeTableChart?systemSid='+systemSid,
        method: 'get',
    })
}


export const getVegetationCoverageTable = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getVegetationCoverageTable?systemSid='+systemSid,
        method: 'get',
    })
}

export const getPestInfoChart = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getPestInfoChart?systemSid='+systemSid,
        method: 'get',
    })
}

export const getPestListTable = (systemSid,surveyType) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getPestListTable?systemSid='+systemSid+'&surveyType='+surveyType,
        method: 'get',
    })
}

export const getPestListTable1 = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getPestListTable1?systemSid='+systemSid,
        method: 'get',
    })
}

export const getPestInfoCount = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getPestInfoCount?systemSid='+systemSid,
        method: 'get',
    })
}

export const getMediaCapitals = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/cloudScreen/getMediaCapitals?systemSid='+systemSid,
        method: 'get',
    })
}